import { useEffect, useState } from 'react';

import { useApiConversationTractiveDiscountCodeRetrieve2 } from '@rover/rsdk/src/apiClient/latest/api-conversation-tractive-discount-code-retrieve-2';
import { ApiConversationTractiveDiscountCodeRetrieve2Type } from '@rover/rsdk/src/apiClient/latest/model/apiConversationTractiveDiscountCodeRetrieve2Type';

type Props = {
  delay: number;
};
const useDelayedTractiveDiscountCodeRetrieve = ({ delay }: Props) => {
  const [isDelayed, setIsDelayed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsDelayed(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return useApiConversationTractiveDiscountCodeRetrieve2(
    { type: ApiConversationTractiveDiscountCodeRetrieve2Type.member_profile },
    {
      query: {
        enabled: isDelayed,
      },
    }
  );
};

export default useDelayedTractiveDiscountCodeRetrieve;
